<template>
    <div>
      <div class="container-form px-3 py-3">  
        <v-card flat class="container-form-inner mb-3">
          <v-card-title>
            <h2 class="font-weight-regular">{{ $t('admissions.titles.work_ref') }}</h2>
          </v-card-title>
          <v-card-text>
            <v-layout v-for="(ref, index) in work_references" row wrap mt-2 align-center :key="index">
              <v-flex xs12 lg3 px-1>
                <h3>Acudiente</h3>
                {{ ref.guardian }}
              </v-flex>
              <v-flex xs12 lg3 px-1>
                <h3>{{ $t('admissions.form.full_name') }}</h3>
                {{ ref.name }}
              </v-flex>
              <v-flex xs12 lg3 px-1>
                <h3>{{ $t('admissions.form.phone_number') }}</h3>
                {{ ref.phone }}
              </v-flex>
              <v-flex xs12 lg3 px-1>
                <h3>Email</h3>
                {{ ref.email }}
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card flat class="container-form-inner mb-3">
          <v-card-title>
            <h2 class="font-weight-regular">{{ $t('admissions.titles.personal_ref') }}</h2>
          </v-card-title>
          <v-card-text>
            <v-layout v-for="(ref, index) in personal_references" row wrap mt-2 align-center :key="index">
              <v-flex xs12 lg3 px-1>
                <h3>Acudiente</h3>
                {{ ref.guardian }}
              </v-flex>
              <v-flex xs12 lg3 px-1>
                <h3>{{ $t('admissions.form.full_name') }}</h3>
                {{ ref.name }}
              </v-flex>
              <v-flex xs12 lg2 px-1>
                <h3>{{ $t('admissions.form.phone_number') }}</h3>
                {{ ref.phone }}
              </v-flex>
              <v-flex xs12 lg3 px-1>
                <h3>Email</h3>
                {{ ref.email }}
              </v-flex>
              <v-flex xs12 lg1 px-1>
                <h3>{{ $t('admissions.form.relation') }}</h3>
                {{ ref.relation }}
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </div>
    </div>
</template>

<script>
export default {
  name: 'admissions-references',
  props: {
    references: {
      type: Array,
      required: true
    },
    family_id: {
      type: String,
    }
  },
  data() {
    return {}
  },
  computed: {
    work_references() {
      return this.references.filter(ref => ref.type === 'Work')
    },
    personal_references() {
      return this.references.filter(ref => ref.type === 'Personal')
    },
  },
}
</script>
<style lang="scss" scoped>
  .container-form{
    background: #6198c8;
  }
  .container-form-inner{
    background: #F2F2F2;
    border-radius: 30px;
  }
  .container-form-inner .v-card__title, .v-expansion-panel__header .v-card__title{
    color: #004990;
    justify-content: center;
    background: #FFF;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/admissions/manage/references.vue